import { Provider } from '@react-spectrum/s2';
import type { PropsWithChildren } from 'react';

import { BridgeProvider } from '@/api/BridgeProvider.tsx';
import { ImsApiProvider } from '@/auth/ImsApiProvider.tsx';

export const Providers = ({ children }: PropsWithChildren) => {
	return (
		<Provider background="base" colorScheme="light">
			<ImsApiProvider>
				<BridgeProvider>{children}</BridgeProvider>
			</ImsApiProvider>
		</Provider>
	);
};
